import {get} from 'lodash';
import React, {Component, PropTypes} from 'react';
import CheckList from './c_CheckList';
import TextField from './c_TextField';

export default class CheckListTextField extends Component {
  static propTypes = {
    className : PropTypes.string,
    checkListClassName : PropTypes.string,
    textfieldClassName : PropTypes.string,
    menuItems : PropTypes.array,
    floatingLabelText : PropTypes.string,
    errorText : PropTypes.string,
    defaultValue : PropTypes.array,
    defaultOtherValue : PropTypes.string,
    value : PropTypes.array,
    otherValue : PropTypes.object,
    dataId : PropTypes.string,
    textfieldContainerClassName: PropTypes.string,
    checkListContainerClassName: PropTypes.string,
    onChange : PropTypes.func,
    onBlur : PropTypes.func
  }

  constructor(props, context) {
    super(props, context);
  }

  handleChange = (event, value, primaryText)  => {
    if (this.props.onChange) {
      return this.props.onChange(event, value, primaryText);
    }
  }

  handleBlur = (event, value, primaryText)  => {
    if (this.props.onBlur) {
      return this.props.onBlur(event, value, primaryText);
    }
  }


  renderSelectedText() {
    const value = get(this.refs, 'CheckList.state.checked', this.props.defaultValue);
    if (value && this.props.menuItems) {
      return this.props.menuItems.reduce((text, item) =>
        value.includes(item.value || item.id) ? `${text.length ? `${text},` : text} ${item.primaryText || item.name}` : text,
        ''
      );
    }
  }

  render() {
    const {
      className,
      checkListClassName,
      textfieldClassName,
      menuItems,
      floatingLabelText,
      errorText,
      defaultValue,
      defaultOtherValue,
      otherValue,
      value,
      textfieldContainerClassName,
      checkListContainerClassName,
      dataId
    } = this.props;

    return (
      <div className={className}>
        <div className={checkListContainerClassName}>
          <CheckList
            className={checkListClassName}
            ref='CheckList'
            data-id={dataId}
            floatingLabelText={floatingLabelText}
            showLabel
            defaultValue={defaultValue}
            menuItems={menuItems}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={errorText}
          />
        </div>
        <div className={textfieldContainerClassName}>
          <TextField
            floatingLabelText=' '
            className={textfieldClassName}
            data-id={`${dataId}Display`}
            disabled
            inputStyle={{textOverflow: 'ellipsis'}}
            value={this.renderSelectedText()}/>
          </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/common/components/CheckListTextField.js